const STORAGE_KEY = 'providerFavorites';

const normalizeProvider = (provider) => ({
  id: provider.id,
  name: provider.name,
  business_logo: provider.business_logo,
  favorited_at: provider.favorited_at || new Date().toISOString(),
});

export const getFavoriteProviders = () => {
  try {
    return JSON.parse(localStorage.getItem(STORAGE_KEY) || '[]');
  } catch {
    return [];
  }
};

export const isFavoriteProvider = (providerId) => (
  getFavoriteProviders().some((provider) => provider.id === Number(providerId))
);

export const addFavoriteProvider = (provider) => {
  const favorites = getFavoriteProviders();
  const normalizedProvider = normalizeProvider(provider);
  const nextFavorites = [
    normalizedProvider,
    ...favorites.filter((favorite) => favorite.id !== normalizedProvider.id),
  ];

  localStorage.setItem(STORAGE_KEY, JSON.stringify(nextFavorites));
  return nextFavorites;
};

export const removeFavoriteProvider = (providerId) => {
  const nextFavorites = getFavoriteProviders().filter((provider) => provider.id !== Number(providerId));
  localStorage.setItem(STORAGE_KEY, JSON.stringify(nextFavorites));
  return nextFavorites;
};
